import {
  Dispatch, SetStateAction,
} from 'react';
import {
  Form,
} from 'semantic-ui-react';
import styled from 'styled-components';
import { Other } from 'simplydo/interfaces';

const AdvancedProfileContainer = styled.div`
`;

type IAdvancedProfileEditor = {
  companyDetails: Other.ICompanyDetails,
  setCompanyDetails: Dispatch<SetStateAction<Other.ICompanyDetails>>,
}

const AdvancedProfileEditor = ({
  setCompanyDetails, companyDetails,
}: IAdvancedProfileEditor) => {


  return (
    <div>
      <AdvancedProfileContainer>
        <Form style={{ marginTop: 20 }}>
          <Form.Group widths={'equal'}>
            <Form.Input placeholder="01234567" label='Company registration number' value={companyDetails?.creditsafeRegNo} onChange={(e, { value }) => setCompanyDetails((prevState) => ({ ...prevState, creditsafeRegNo: value }))} />
            <Form.Input placeholder="GB-000000" label='VAT registration number' value={companyDetails?.vatNo} onChange={(e, { value }) => setCompanyDetails((prevState) => ({ ...prevState, vatNo: value }))} />
          </Form.Group>
        </Form >
      </AdvancedProfileContainer >
    </div >
  );
};

export default AdvancedProfileEditor;
